import React, { useState, useEffect } from 'react';

const Alert = () => {
    const [visible, setVisible] = useState(true);

    if (!visible) return null;

    return (
        <div className="w-full bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 mb-4 max-w-screen-lg mx-auto rounded-md shadow-sm">
            <div className="flex items-center justify-between">
                <div className="flex items-center">
                    {/* Heroicons information icon */}
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500 mr-3" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-8.707-1.707a1 1 0 011.414 0L11 9.586V13a1 1 0 11-2 0v-2.586l-.293-.293a1 1 0 010-1.414zM10 5a1 1 0 100 2 1 1 0 000-2z" clipRule="evenodd" />
                    </svg>
                    <p className="text-sm font-medium">
                        Welcome! Try our new Class Schedule Search for an easier way to find your classes.  If you need help, with Registering for Classes, click <a href="https://pasadena.edu/get-started/support/drop-a-class.php" className="underline text-blue-800 hover:text-blue-600" target="_blank" rel="noopener noreferrer">here</a>.
                    </p>
                </div>
                <button onClick={() => setVisible(false)} className="ml-4 text-blue-700 hover:text-blue-900 font-bold text-lg">
                    ×
                </button>
            </div>
        </div>
    );
};

export default Alert;